module.exports = __webpack_public_path__ + "static/media/slunicko_montessori.0fb25f3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/slunicko_montessori.jpg
// module id = 445
// module chunks = 0